import React, { useEffect, useState } from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CButton,
  CRow,
  CCol,
  CFormInput,
  CFormSelect,
  CAlert,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationList,
  notificationsClearAll,
  notificationsMarkRead,
} from "../../features/user/userSlice";
import AppLoader from "../../components/seller/AppLoader";
import { timeAgo } from "../../utils/timeAgo";

const initialNotifications = [
  {
    id: 1,
    title: "New Bid Received",
    description: "A buyer has placed a new bid on your product.",
    time: "2 minutes ago",
    read: false,
  },
  {
    id: 2,
    title: "Order Confirmed",
    description: "Your order for Copper Wire has been accepted.",
    time: "1 hour ago",
    read: true,
  },
  {
    id: 3,
    title: "Stock Alert",
    description: "Aluminium stock is below threshold.",
    time: "Yesterday",
    read: false,
  },
  {
    id: 4,
    title: "New Bid Received",
    description: "A buyer has placed a new bid on your product.",
    time: "2 minutes ago",
    read: false,
  },
  {
    id: 5,
    title: "Order Confirmed",
    description: "Your order for Copper Wire has been accepted.",
    time: "1 hour ago",
    read: true,
  },
  {
    id: 6,
    title: "Stock Alert",
    description: "Aluminium stock is below threshold.",
    time: "Yesterday",
    read: false,
  },
];

const Notifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.user.notifications || []);
  const notificationLoading = useSelector(
    (state) => state.user.notificationLoading
  );
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getNotificationList())
      .unwrap()
      .catch((error) => {
        console.error("Failed to load notifications", error);
        // Show toast or fallback UI
      });
  }, [dispatch]);

  const filtered = Array.isArray(notifications)
    ? notifications.filter((n) =>
        n.title.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  // console.log('notifications:',filtered)
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / entriesPerPage);

  const handleMarkAsRead = (id) => {
    dispatch(notificationsMarkRead(id)).unwrap();
  };

  const handleClearAll = () => {
    dispatch(notificationsClearAll()).unwrap();
  };

  if (notificationLoading) return <AppLoader />;
  return (
    <div className="container-fluid px-3">
      <CRow className="mt-4 mb-3">
        <CCol>
          <h4 className="mb-0">Notifications</h4>
        </CCol>
      </CRow>

      <CCard>
        <CCardHeader>
          <CRow className="align-items-center">
            <CCol>
              <h6
                className="text-muted mb-0 d-flex align-items-center"
                style={{ height: "100%" }}
              >
                Your Notifications
              </h6>
            </CCol>
            <CCol className="text-end">
              <CButton color="danger" size="sm" onClick={handleClearAll}>
                Clear All
              </CButton>
            </CCol>
          </CRow>
          <hr className="mt-2 mb-2" />
          <CRow className="align-items-center">
            <CCol md={6}>
              Show{" "}
              <CFormSelect
                size="sm"
                value={entriesPerPage}
                onChange={(e) => setEntriesPerPage(Number(e.target.value))}
                style={{ display: "inline-block", width: "auto" }}
                options={[
                  { label: "5", value: "5" },
                  { label: "10", value: "10" },
                  { label: "25", value: "25" },
                ]}
              />{" "}
              entries
            </CCol>
            <CCol md={6} className="text-end">
              Search:{" "}
              <CFormInput
                type="text"
                size="sm"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ display: "inline-block", width: "200px" }}
              />
            </CCol>
          </CRow>
        </CCardHeader>

        <CCardBody>
          {currentData.length === 0 && (
            <CAlert color="light">No notifications found.</CAlert>
          )}

          {currentData.map((note) => (
            <CCard
              key={note.id}
              className={`mb-3 px-4 py-3 border-0 shadow-sm rounded-4 notification-card ${
                !note.is_read ? "bg-info-subtle" : "bg-white"
              }`}
              style={{ transition: "background 0.3s" }}
            >
              <div className="d-flex align-items-start justify-content-between">
                <div className="d-flex gap-3 align-items-start">
                  {!note.is_read && (
                    <span
                      className="mt-1 rounded-circle bg-info"
                      style={{ width: "10px", height: "10px" }}
                    ></span>
                  )}
                  <div>
                    <h6 className="mb-1 fw-semibold">{note.title}</h6>
                    <p className="mb-1 text-muted small">{note.message}</p>
                    <small className="text-body-secondary">
                      {timeAgo(note.created_at)}
                    </small>
                  </div>
                </div>
                {!note.is_read && (
                  <CButton
                    size="sm"
                    color="light"
                    className="text-info border rounded-pill px-3"
                    onClick={() => handleMarkAsRead(note.id)}
                  >
                    Mark as Read
                  </CButton>
                )}
              </div>
            </CCard>
          ))}

          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {indexOfFirst + 1} to{" "}
              {Math.min(indexOfLast, filtered.length)} of {filtered.length}{" "}
              entries
            </div>
            <div className="d-flex align-items-center">
              <CButton
                size="sm"
                color="light"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                className="me-2"
              >
                Prev
              </CButton>

              {[...Array(totalPages)].map((_, i) => (
                <CButton
                  key={i}
                  size="sm"
                  color={currentPage === i + 1 ? "primary" : "light"}
                  onClick={() => setCurrentPage(i + 1)}
                  className="me-2"
                >
                  {i + 1}
                </CButton>
              ))}

              <CButton
                size="sm"
                color="light"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default Notifications;
